import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { RelatedTicketModel } from '../../../core/models/related-ticket-model.model';

@Injectable({
    providedIn: 'root',
})
export class LinkedTicketsService {
    constructor(private httpClient: HttpClient) {}

    getAll(ticketId: number): Observable<RelatedTicketModel[]> {
        return this.httpClient.get<RelatedTicketModel[]>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/relatedTickets',
        );
    }

    add(ticketId: number, relatedTicketId: number): Observable<void> {
        return this.httpClient.post<void>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/relatedTickets/' + relatedTicketId,
            null,
        );
    }

    remove(ticketId: number, relatedTicketId: number): Observable<void> {
        return this.httpClient.delete<any>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/relatedTickets/' + relatedTicketId,
        );
    }
}
